import {Component, OnInit} from '@angular/core';
import {UserService} from '../service/user.service';
import {Keys, StorageService} from '../service/storage.service';
import {Location} from '@angular/common';
import {MatDialog} from '@angular/material/dialog';
import {EmailVerificationModalComponent} from '../email-verification-modal/email-verification-modal.component';
import {LenderDetailsService} from '../service/lender-details.service';
import {BankAccount} from '../model/bank-account';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
    public name: string;
    public email: string;
    public mobile_no: string;
    public isLender: boolean;
    public address: string;
    public bankAccount: BankAccount;
    public finzyDomain: boolean;
    public otherDomain: boolean;
    public dialog: MatDialog;
    private userService: UserService;
    private storageService: StorageService;
    private location: Location;

    constructor(userService: UserService, storageService: StorageService, location: Location, dialog: MatDialog, private lenderDetailsService: LenderDetailsService) {
        this.userService = userService;
        this.storageService = storageService;
        this.location = location;
        this.dialog = dialog;
    }

    public async ngOnInit() {
        if (this.storageService.getItem(Keys.DOMAIN) === 'tripfactory') {
            this.finzyDomain = false;
            this.otherDomain = true;
        } else {
            this.finzyDomain = true;
            this.otherDomain = false;
        }
        this.isLender = this.storageService.getItem(Keys.LENDER) === 'true';

        await this.fetchAndShowProfileInformation();
        if (this.isLender) {
            await this.fetchAndShowLenderBankAccountDetails();
        }
    }

    public async openDialog(): Promise<void> {
        await this.dialog.open(EmailVerificationModalComponent,
            {
                data: {title: 'Update your email id'},
                width: '50vw',
                minWidth: '320px'
            })
            .afterClosed()
            .toPromise();
        await this.fetchAndShowProfileInformation();
    }

    public backToPreviousPage() {
        this.location.back();
    }

    private async fetchAndShowProfileInformation() {
        const profileId = this.storageService.getItem(Keys.PROFILE_ID);
        const userInformation = await this.userService.getProfileDetails(profileId);
        this.name = userInformation.name;
        this.email = userInformation.email;
        this.mobile_no = userInformation.mobile_no;
    }

    private async fetchAndShowLenderBankAccountDetails() {
        const lenderId = this.storageService.getItem(Keys.LENDER_ID);
        const lender = await this.lenderDetailsService.getLenderDetails(lenderId);
        this.address = lender.lender_info.correspondence_address.address;
        this.bankAccount = lender.lender_info.bank_account;
    }
}
